import { render, staticRenderFns } from "./EconomyScreen.vue?vue&type=template&id=2cf2b0d6&scoped=true"
import script from "./EconomyScreen.vue?vue&type=script&lang=js"
export * from "./EconomyScreen.vue?vue&type=script&lang=js"
import style0 from "./EconomyScreen.vue?vue&type=style&index=0&id=2cf2b0d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2b0d6",
  null
  
)

export default component.exports